// @owners { team: patients }

type Params = {
  isEditing: boolean;
  editOrderShipmentID: number | null | undefined;
  destinationShipmentID: number;
  orderPrescriptionIDs: number[];
  editShipmentPrescriptionIDs: number[];
};

export const getEditOrderShipmentIdForAddToShipment = ({
  isEditing,
  editOrderShipmentID,
  destinationShipmentID,
  orderPrescriptionIDs,
  editShipmentPrescriptionIDs,
}: Params): number | null => {
  if (!isEditing || !editOrderShipmentID || editOrderShipmentID === destinationShipmentID) {
    return null;
  }

  const editShipmentPrescriptionIDSet = new Set(editShipmentPrescriptionIDs);
  const orderPrescriptionIDSet = new Set(orderPrescriptionIDs);

  if (editShipmentPrescriptionIDSet.size === 0 || editShipmentPrescriptionIDSet.size !== orderPrescriptionIDSet.size) {
    return null;
  }

  const isExactMatch = [...editShipmentPrescriptionIDSet].every((id) => orderPrescriptionIDSet.has(id));

  return isExactMatch ? editOrderShipmentID : null;
};
